var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('headerElem'),_c('p',[_vm._v("Notre opération débute le 20 Juin 2022")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }